/* SilkPearl welcome popup.

   Opens once after a delay, remembers that it was seen, and applies the
   subscribe discount code to the session on success — the same
   POST /contact then GET /discount/CODE path the bundle widget uses, so both
   surfaces tag the customer identically.

   Deliberately does NOT open immediately on load. A promo that covers the page
   the instant someone arrives from search is the intrusive-interstitial
   pattern Google penalises on mobile, and it reads as hostile. The delay is a
   section setting.
*/
(function () {
  var root = document.querySelector('[data-sp-popup]');
  if (!root) return;

  var KEY = 'sp-popup-v1';
  var card = root.querySelector('[data-sp-popup-card]');
  var form = root.querySelector('[data-sp-popup-form]');
  var email = root.querySelector('[data-sp-popup-email]');
  var submit = root.querySelector('[data-sp-popup-submit]');
  var msg = root.querySelector('[data-sp-popup-msg]');
  var successWrap = root.querySelector('[data-sp-popup-success]');

  var delay = Number(root.getAttribute('data-delay') || 8) * 1000;
  var days = Number(root.getAttribute('data-days') || 14);
  var code = root.getAttribute('data-code') || '';
  var lastFocus = null;

  /* localStorage throws in private mode on some browsers; a popup is never
     worth breaking the page over. */
  function remember(state) {
    try { localStorage.setItem(KEY, JSON.stringify({ state: state, at: Date.now() })); } catch (e) { /* ignore */ }
  }
  function suppressed() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      var v = JSON.parse(raw);
      if (v.state === 'subscribed') return true;
      return Date.now() - v.at < days * 86400000;
    } catch (e) { return false; }
  }

  function focusables() {
    return Array.prototype.filter.call(
      card.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKey(e) {
    if (e.key === 'Escape') { close('dismissed'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (suppressed()) return;
    /* Don't stack on top of the cart drawer — whatever the shopper is doing
       there matters more than this. */
    if (document.querySelector('#sp-cart-drawer.is-open')) return;

    lastFocus = document.activeElement;
    root.hidden = false;
    void root.offsetWidth; /* rAF is paused in background tabs; force reflow */
    root.classList.add('is-open');
    document.addEventListener('keydown', onKey);
    if (email) email.focus();
  }

  function close(state) {
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    remember(state || 'dismissed');
    var done = function () { root.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) done();
    else setTimeout(done, 340);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sp-popup-close]') || e.target.closest('[data-sp-popup-veil]')) {
      e.preventDefault();
      close('dismissed');
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var address = email ? email.value.trim() : '';
      if (!address || address.indexOf('@') < 1) {
        if (msg) { msg.textContent = 'Enter an email address and the code is yours.'; msg.classList.add('sp-pop__msg--err'); }
        if (email) email.focus();
        return;
      }
      if (msg) { msg.textContent = ''; msg.classList.remove('sp-pop__msg--err'); }
      if (submit) { submit.disabled = true; submit.textContent = 'One moment'; }

      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[email]', address);
      body.set('contact[tags]', 'newsletter,welcome-popup');

      fetch('/contact', { method: 'POST', body: body })
        .then(function () { return code ? fetch('/discount/' + encodeURIComponent(code)) : null; })
        .then(function () {
          remember('subscribed');
          if (successWrap) {
            form.hidden = true;
            successWrap.hidden = false;
            var h = successWrap.querySelector('h2, [data-sp-popup-success-title]');
            if (h) h.focus ? h.focus() : null;
          }
        })
        .catch(function () {
          if (msg) {
            msg.textContent = 'Signed up, but the code did not attach. Enter it at checkout.';
            msg.classList.add('sp-pop__msg--err');
          }
        })
        .finally(function () {
          if (submit) { submit.disabled = false; submit.textContent = submit.getAttribute('data-label') || 'Get my code'; }
        });
    });
  }

  if (!suppressed()) setTimeout(open, delay);
})();
